import { ColumnState } from 'ag-grid-community'
import { ITableColumnConfig } from './types'

export const LOCAL_STORAGE_KEY = 'tableConfiguration'

export function getStoredConfigs(): ITableColumnConfig {
  try {
    const raw = localStorage.getItem(LOCAL_STORAGE_KEY)
    return raw ? (JSON.parse(raw) as ITableColumnConfig) : {}
  } catch (error) {
    console.warn('Failed to parse column config from localStorage:', error)
    return {}
  }
}

export function saveColumnStateToStorage(
  page: string,
  table: string,
  columnState: ColumnState[]
): void {
  const config = getStoredConfigs()

  if (!config[page]) {
    config[page] = {}
  }

  config[page][table] = columnState
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(config))
}

export function getColumnStateFromStorage(
  page: string,
  table: string
): ColumnState[] | null {
  const config = getStoredConfigs()
  return config?.[page]?.[table] ?? null
}

export function removeSavedColumnStateFromStorage(page: string, table: string) {
  const config = getStoredConfigs()
  if (config[page][table]) {
    delete config[page][table]
  }
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(config))
}
